import Bridge from './bridge';
import {getState, getStore} from '../../lib/app-state-hoc.jsx';

import {
    onLoadedProject
} from '../../reducers/project-state';

import {
    openLoadingProject,
    closeLoadingProject
} from '../../reducers/modals';

class UnityProjectsActions {
    constructor () {
        this._initialize();
    }

    _initialize () {
        Bridge.addListener('PullProject', this._onPullProjectMessage.bind(this));
        Bridge.addListener('LoadProject', this._onLoadProjectMessage.bind(this));

        console.debug('[UnityProjectsActions._initialize] Initialized');
    }

    async _onPullProjectMessage () {
        console.debug('[UnityProjectsActions._onPullProjectMessage] Received message');

        try {
            const state = getState();
            if (!state) {
                console.error('[UnityProjectsActions._onPullProjectMessage] No state found');
                return;
            }

            const saveSb3Project = state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm);
            const blobFile = await saveSb3Project(); // Blob
      
            // Convert Blob to base64
            const fileReader = new FileReader();
            fileReader.onload = () => {
                this._sendUploadProjectMessage(fileReader.result.replace(/^data:application\/x.scratch.sb3;base64,/, ''));
            };
            fileReader.onerror = error => {
                console.error('[UnityProjectsActions._onPullProjectMessage] Error while reading file', error);
            };
            fileReader.readAsDataURL(blobFile);
        } catch (e) {
            console.error('[UnityProjectsActions._onPullProjectMessage] Error while saving file', e);
        }
    }

    async _onLoadProjectMessage (payload) {
        console.debug('[UnityProjectsActions._onLoadProjectMessage] Received message', payload);

        if (!payload || typeof payload !== 'string') {
            console.error('[UnityProjectsActions._onLoadProjectMessage] Invalid payload');
            return;
        }

        if (!payload.startsWith('{')) {
            // Original file was a sb3 binary file, then it was converted to base64
            // We need to convert the original base64 to Blob

            // Decode base64
            const decoded = atob(payload);
            const decodedLength = decoded.length;
            const decodedArray = new Uint8Array(decodedLength);
            for (let i = 0; i < decodedLength; i++) {
                decodedArray[i] = decoded.charCodeAt(i);
            }

            // Create Blob
            const blob = new Blob([decodedArray], {type: 'application/octet-stream'});
            const fileReader = new FileReader();
            fileReader.onload = () => {
                this._loadProject(fileReader.result);
            };
            fileReader.onerror = error => {
                console.error('[UnityProjectsActions._onLoadProjectMessage] Error while decoding payload', error);
            };
            fileReader.readAsArrayBuffer(blob);
            return;
        }

        this._loadProject(payload);
    }

    _sendUploadProjectMessage (fileContent) {
        console.debug('[UnityProjectsActions._sendUploadProjectMessage] Sending project to Unity');
        Bridge.sendMessage('UploadProject', fileContent);
    }

    async _loadProject (fileContent) {
        try {
            this._onLoadingStarted();

            const state = getState();
            await state.scratchGui.vm.loadProject(fileContent).then(() => {
                this._onLoadingFinished('LOADING_VM_FILE_UPLOAD', true);
            })
                .catch(error => {
                    console.error('[UnityProjectsActions._loadProject] Error while loading project', error);
                    alert('Error loading project'); // eslint-disable-line no-alert
                    this._onLoadingFinished('LOADING_VM_FILE_UPLOAD', true);
                });
        } catch (e) {
            console.error('[UnityProjectsActions._loadProject] Error while parsing file content', e);
            this._onLoadingFinished('LOADING_VM_FILE_UPLOAD', true);
        }
    }

    _onLoadingFinished (loadingState, success) {
        const {dispatch} = getStore();
        dispatch(onLoadedProject(loadingState, true, success));
        dispatch(closeLoadingProject());
    }

    _onLoadingStarted () {
        const {dispatch} = getStore();
        dispatch(openLoadingProject());
    }
}

export default UnityProjectsActions;
